import { render, staticRenderFns } from "./PrimaryColorPicker.vue?vue&type=template&id=76d2bee2&scoped=true"
import script from "./PrimaryColorPicker.vue?vue&type=script&lang=js"
export * from "./PrimaryColorPicker.vue?vue&type=script&lang=js"
import style0 from "./PrimaryColorPicker.vue?vue&type=style&index=0&id=76d2bee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d2bee2",
  null
  
)

export default component.exports